<template>
  <md-card-content>
                            <div class="extra_space">
                              <h1 class="md-body-2 text-left">
                                <b>DATA SOURCES AND LIMITATIONS</b>
                              </h1>
                              <p>Bizminer data is widely accepted for industry analytical work, benchmarking, valuations,
                                forensics and litigation. Raw data analyzed for Bizminer reports is sourced from an array
                                of the
                                nation's government and private statistical sources. None of these raw data sources
                                creates the final measures reflected in Bizminer industry profiles. In total, Bizminer
                                accesses over a
                                billion sourced data points from 15 million business operations for each of its twice
                                annual updates covering a 3-5 year time series. Historical data and Bizminer algorithms
                                are used to
                                inform and test projections for non-reporting firms. Data elements are sourced
                                specifically from:
                              </p> <br>
                              <ul class="columnize">
                                <li>IRS Statistics of Income</li>
                                <li>IRS SOI Corporation Tax Book</li>
                                <li>IRS Sole Proprietorship Tables</li>
                                <li>US Economic Census</li>
                                <li>US Census Quarterly Financial Reports</li>
                                <li>US Census County Business Patterns</li>
                                <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                                <li>Bureau of Labor Statistics Monthly Unemployment Reports</li>
                                <li>Bureau of Labor Statistics Annual Wage Survey</li>
                                <li>Bureau of Labor Statistics Industry Productivity Reports</li>
                                <li>Bureau of Labor Statistics Price Indices</li>
                                <li>Bureau of Labor Statistics Consumer Price Index</li>
                                <li>National Agricultural Statistical Service</li>
                                <li>US Census Retail Trade Report</li>
                                <li>Data Axle</li>
                                <li>DealStats</li>
                                <li>American Community Survey</li>
                              </ul><br>
                                <p>No representation is made as to the accuracy of the databases utilized or the results
                                  of subsequent analyses. Neither the Bizminer® nor its resellers have undertaken
                                  independent
                                  primary research to confirm the accuracy of the data utilized in the Profile analyses.
                                  Neither the Bizminer® nor its resellers are responsible for conclusions drawn or
                                  decisions made
                                  based upon this data or analysis. In no event will Bizminer® or its resellers be liable
                                  for any damages, direct, indirect, incidental or consequential resulting from the use of
                                  the
                                  information contained in Bizminer® reports.</p> <br>
                                <p>The Valuations is an informational tool, not a guide to action. Do not use the report in
                                  place of a certified valuation, or as the basis of any specific business-related or
                                  other financial
                                  transaction. For that we recommend obtaining an appraisal from a business broker, a
                                  valuation from a certified valuation professional, or both. You should not attempt to
                                  use
                                  Valuations Reports to secure a business or personal loan. Be aware that the Valuations may
                                  not consider market or firm idiosyncrasies that can influence the actual value or
                                  selling price.
                                </p><br>
                            </div>
  </md-card-content>
</template>

<script>
import {NavTabsCard} from "@/components";
import CPHeader from "./_partials/CPHeader.vue";
//import { mapState } from 'vuex';

export default {
  name:'ValueProposition',
  components: {
    //NavTabsCard,
    //CPHeader
  },
}
</script>
<style lang="scss">


.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.comp-profile {
  display: flex;
  align-items: start;

  .md-layout {
    text-align: center;

    p {
      margin-left: 0 !important;
    }
  }

  .market-insights {
    p {
      color: #3b7ef1;
    }
  }
}

.table-box-margin {
  .md-layout-item {
    .md-card {
      margin: 15px 0 !important;
    }
  }
}

.company-terms {
  p {
    margin: 0 !important;
  }
}
</style>

